/**
 * FAQAccordion — accordion met dark cards, opent één per keer of allemaal.
 * Gebruikt native <details>/<summary> voor zero-dep + accessibility.
 */
export default function FAQAccordion({ items = [], testId = 'ps-faq' }) {
  return (
    <div className="space-y-2.5" data-testid={testId}>
      {items.map((it, idx) => (
        <details
          key={it.id || idx}
          className="group rounded-2xl bg-white/5 border border-white/10 px-4 sm:px-5 py-3.5"
          data-testid={`${testId}-item-${idx + 1}`}
        >
          <summary className="flex items-start justify-between gap-3 cursor-pointer list-none">
            <span className="text-[15px] font-medium text-white leading-snug pr-2">
              {it.q}
            </span>
            <span className="text-emerald-300 text-sm leading-none mt-1 group-open:rotate-180 transition-transform">▾</span>
          </summary>
          <div className="mt-3 text-sm text-white/75 leading-relaxed">
            {it.a}
          </div>
        </details>
      ))}
    </div>
  );
}
